<template>
  <div>
    <base-page-heading title="Commission Plans">
      <template #extra>
        <b-button
          v-if="$can('create', 'CommissionPlan')"
          variant="primary"
          v-b-modal.commission-plans-add-modal
          v-b-tooltip.hover
          title="Create a new Commission Plan"
        >
          <i class="fa fa-plus" />
          <span class="ml-1 d-none d-md-inline">New Commission Plan</span>
        </b-button>

        <sfs-download-button
          v-b-tooltip.hover
          :provider-params="filters"
          filename="Commission Plans.csv"
          :file-provider="$commissionPlansAPI.getSpreadsheet"
          title="Download spreadsheet"
          label="Download"
          class="d-none d-md-inline"
        />

        <sfs-download-button
          v-b-tooltip.hover
          :provider-params="filters"
          filename="Commission Plans.csv"
          :file-provider="$commissionPlansAPI.getSpreadsheet"
          title="Download spreadsheet"
          class="d-md-none"
        />
      </template>
    </base-page-heading>
    <div class="content">
      <b-row>
        <b-col>
          <commission-plans-list-filter
            :columns="columns"
            :initial-filters="filters"
            @filters-applied="applyFilters"
          />
        </b-col>
      </b-row>
      <commission-plans-table
        :filters="filters"
        :columns="columns"
        :current-page="pagination.currentPage"
        :per-page="pagination.perPage"
        :key="tableKey"
      />
    </div>

    <!-- Page Modals -->
    <commission-plans-new-modal
      v-if="$can('create', 'CommissionPlan')"
      @on-save="refreshTable"
    />
  </div>
</template>

<script>
import CommissionPlansNewModal from '@/components/admin/commissionPlans/NewModal.vue';
import CommissionPlansListFilter from '@/components/admin/commissionPlans/ListFilter.vue';
import CommissionPlansTable from '@/components/admin/commissionPlans/Table.vue';
import listMixin from '@/mixins/listMixin';
import { COMMISSION_PLAN_TABLE_NAME } from '@/constants/commissionPlans';

export default {
  name: 'CommissionPlansList',
  components: {
    CommissionPlansNewModal,
    CommissionPlansListFilter,
    CommissionPlansTable,
  },
  mixins: [listMixin],
  props: {
    text: String,
    name: String,
    active: String,
  },
  data() {
    return {
      tableName: COMMISSION_PLAN_TABLE_NAME,
      filters: {
        text: this.text,
        name: this.name,
        active: this.active,
      },
      tableKey: Date.now(),
    };
  },
  methods: {
    refreshTable() {
      this.tableKey = Date.now();
    }
  },
};
</script>
